<template>
    <b-container fluid class="p-0">
        <LocationTracker/>
        <b-row class="no-gutters">
            <b-col cols="2">
                <Filter1/>
            </b-col>
            <b-col>
                <Result/>
            </b-col>
            <b-col cols="4">
                <GLMap/>
            </b-col>
        </b-row> 
    </b-container>
</template>

<style scoped>


</style>

<script>
import GLMap from '../components/map/GLMap'
//import MiniappTray from '../components/miniapp/MiniappTray'
//import Sidebar from '../components/sidebar/Sidebar'
import Result from '../components/other/result/Result'
import Filter1 from '../components/other/Filter1'
import LocationTracker from '../components/common/LocationTracker'
import _ from 'lodash';

export default {
    name: 'Home',
    components: {
        GLMap,
        //MiniappTray,
//        Sidebar,
        Result,
        Filter1,
        LocationTracker
    },
    computed: {
        placeCurrentResource: {
            get() {
                return this.$store.state.place_current_resource
            }
        }
    },
    watch: {
    },
    methods: {
    },
    mounted() {
        console.log('mounted')
        console.log('route query', this.$route.query)
        this.$root.$on('validGPS', () => {
            console.log('received validGPS event from Search')

            // check if there is a route query params
            if (!_.isEmpty(this.$route.query)) {
                console.log('dispatching retrievePlacesSearch')
                var payload = {
                    text: this.$route.query.text,
                    location: this.$route.query.location
                }
                // TODO there is a race condition where we dispatch event
                // and the map is not yet loaded, so we are delaying event dispatch
                // by 500 ms (assuming map is already loaded)
                var vm = this
                setTimeout(() => {
                    vm.$store.dispatch('retrievePlacesSearch', payload)
                }, 1000);
                
            }

            if (this.placeCurrentResource === 'nearyou') {
                console.log('dispatching retrievePlacesNearYou')
                this.$store.dispatch('retrievePlacesNearYou')
            }
        })
        
    }
}
</script>